(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('categoryAddAction', {
      controller: Controller,
      templateUrl: 'actions/category/add/add-category.action.html',
      bindings: {
        then: '&',
        catch: '&'
      }
    });
}());
